import React from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import { Row, Col } from 'react-flexbox-grid';

import filter from '../../assets/images/filtros.svg';
import searchIcon from '../../assets/images/lupa.svg';
import {
  DISTANCE_TEAM,
  DISTANCE_USER,
  DEFAULT_DISTANCE_INDIVIDUAL,
  DEFAULT_DISTANCE_TEAM,
} from '../../utils/utils';
import './nav.scss';

const Nav = ({
  openFilter,
  selectedTab,
  filterText,
  setFilterText,
  distanceFilter,
  setDistanceFilter,
  distanceTeamFilter,
  setDistanceTeamFilter,
}) => {
  // Según el tab activo, se utilizan distintos arrays de opciones y se usa el valor correspondiente:
  const distanceOptions = selectedTab === 0 ? DISTANCE_USER : DISTANCE_TEAM;
  const selectedDistance =
    selectedTab === 0 ? distanceFilter : distanceTeamFilter;

  const handleDistanceChange = (event) => {
    if (selectedTab === 0) {
      setDistanceFilter(event.target.value);
    } else {
      setDistanceTeamFilter(event.target.value);
    }
  };

  return (
    <nav className='nav'>
      <Col xs={12}>
        <Row className='nav-row'>
          {/* Vista Desktop: Search input y select en la misma fila */}
          <Col xs={12} md={6} className='select-container '>
            <Row className='segment-select-row'>
              <Col xs className='select-auto'>
                <FormControl className='segment-select-container'>
                  <Select
                    autoWidth
                    className='segment-select'
                    labelId='distance-select-label'
                    id='distance-select'
                    value={selectedDistance}
                    onChange={handleDistanceChange}
                  >
                    {distanceOptions.map((option) => (
                      <MenuItem
                        key={`${option.label}-${String(option.value)}`}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            </Row>
          </Col>

          <Col xs={12} md>
            <Row className='segment-select-row'>
              {setFilterText && (
                <Col xs md className=''>
                  <div className='container-flex'>
                    <div className='search-container'>
                      <img
                        src={searchIcon}
                        alt='search-icon'
                        className='search-icon'
                      />
                      <input
                        placeholder='Nombre…'
                        value={filterText}
                        onChange={(event) => setFilterText(event.target.value)}
                      />
                    </div>
                  </div>
                </Col>
              )}
              {openFilter && (
                <Col className=''>
                  <div className='filter-container'>
                    <img
                      onClick={() => openFilter()}
                      src={filter}
                      alt='filter'
                      className='nav_filter'
                    />
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </nav>
  );
};

Nav.propTypes = {
  openFilter: PropTypes.func,
  selectedTab: PropTypes.number,
  filterText: PropTypes.string,
  setFilterText: PropTypes.func,
  distanceFilter: PropTypes.any,
  setDistanceFilter: PropTypes.func,
  distanceTeamFilter: PropTypes.any,
  setDistanceTeamFilter: PropTypes.func,
};

Nav.defaultProps = {
  filterText: '',
  setFilterText: null,
  openFilter: null,
  selectedTab: 0,
  distanceFilter: DEFAULT_DISTANCE_INDIVIDUAL,
  distanceTeamFilter: DEFAULT_DISTANCE_TEAM,
};

export default Nav;
